module.exports = __webpack_public_path__ + "img/seo_gchess_item04.e5ff03e.webp";